(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ground_shipping"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const drawers = document.querySelectorAll('.shipping-drawer');

    const focusableSelectors = `
    a[href], button, textarea, input, select,
    [tabindex]:not([tabindex="-1"])
  `;

    drawers.forEach((drawer) => {
      const openBtn = document.querySelector(`[aria-controls="${drawer.id}"]`);
      const closeBtn = drawer.querySelector('.drawer-close');

      let lastFocusedElement = null;

      function getFocusableElements() {
        return drawer.querySelectorAll(focusableSelectors);
      }

      function openDrawer() {
        lastFocusedElement = document.activeElement;

        drawer.classList.add('active');
        drawer.removeAttribute('hidden');
        document.body.classList.add('shipping-drawer-open');

        openBtn.setAttribute('aria-expanded', 'true');

        const focusables = getFocusableElements();
        if (focusables.length) focusables[0].focus();

        document.addEventListener('keydown', trapFocus);
      }

      function closeDrawer() {
        drawer.classList.remove('active');
        drawer.setAttribute('hidden', true);
        document.body.classList.remove('shipping-drawer-open');

        openBtn.setAttribute('aria-expanded', 'false');

        document.removeEventListener('keydown', trapFocus);

        if (lastFocusedElement) lastFocusedElement.focus();
      }

      function trapFocus(e) {
        const focusables = getFocusableElements();
        if (!focusables.length) return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.key === 'Tab') {
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }

        if (e.key === 'Escape') {
          closeDrawer();
        }
      }

      // OPEN
      if (openBtn) {
        openBtn.addEventListener('click', openDrawer);
      }

      // CLOSE BUTTON
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
      }

      // BACKDROP CLICK
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) {
          closeDrawer();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Get all quantity components
    const allSelectors = document.querySelectorAll('quantity-selector-component');

    // Filter ONLY PDP + Sticky (exclude cart using data-cart-line)
    const selectors = Array.from(allSelectors).filter((selector) => {
      return !selector.querySelector('[data-cart-line]');
    });

    // Stop if not on PDP
    if (!selectors.length) return;

    const productTitle =
      document
        .querySelector('#product-heading-h1, .product-title, [data-product-title]')
        ?.textContent?.trim() || 'Product';

    function getUnitPriceText() {
      const priceEl = document.querySelector(
        '.product-details .price-block .price, .product-information .price-block .price, product-price .price'
      );
      return priceEl?.textContent?.trim() || '';
    }

    function announceQuantity(value, activeSelector) {
      const unitPrice = getUnitPriceText();
      let message = `${productTitle}: quantity ${value}`;
      if (unitPrice) {
        message += `, price ${unitPrice}`;
      }

      // Clear every PDP region first so sticky + main never both announce.
      for (const selector of selectors) {
        const status = selector.querySelector('[data-quantity-status]');
        if (status instanceof HTMLElement) status.textContent = '';
      }

      const status =
        activeSelector instanceof HTMLElement
          ? activeSelector.querySelector('[data-quantity-status]')
          : null;
      if (!(status instanceof HTMLElement)) return;

      // Clear then set so repeated identical values still announce.
      requestAnimationFrame(() => {
        status.textContent = message;
      });
    }

    function updateAll(value, { announce = false, activeSelector = null } = {}) {
      selectors.forEach((selector) => {
        const input = selector.querySelector('input[type="number"]');
        const minusBtn = selector.querySelector('.quantity-minus');
        const plusBtn = selector.querySelector('.quantity-plus');

        if (!input || !minusBtn || !plusBtn) return;

        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || Infinity;

        input.value = value;

        minusBtn.toggleAttribute('disabled', value <= min);
        minusBtn.setAttribute('aria-disabled', value <= min);

        plusBtn.toggleAttribute('disabled', value >= max);
        plusBtn.setAttribute('aria-disabled', value >= max);
      });

      if (announce) {
        announceQuantity(value, activeSelector);
      }
    }

    // Sync events across all PDP selectors
    selectors.forEach((selector) => {
      const input = selector.querySelector('input[type="number"]');
      if (!input) return;

      input.addEventListener('change', () => {
        updateAll(parseInt(input.value) || 1, { announce: true, activeSelector: selector });
      });

      selector.addEventListener('click', (event) => {
        const btn = event.target.closest('.quantity-minus, .quantity-plus');
        if (!btn) return;

        setTimeout(() => {
          updateAll(parseInt(input.value) || 1, { announce: true, activeSelector: selector });
        }, 30);
      });
    });

    // Always start with 1 (no announcement on initial sync)
    updateAll(1);
  });
  } catch(e) { console.error(e); }
})();

})();
